import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '2.25rem 0 1rem 0',
    padding: '0 3.5rem',

    [theme.breakpoints.down('md')]: {
      margin: '1rem 0 0 0'
    },

    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0 0 0',
      padding: '0 1.5rem'
    },

    [theme.breakpoints.down(429)]: {
      margin: '1rem 0 0 0',
      padding: '0 0.325rem'
    }
  },

  button: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
